module.exports = __webpack_public_path__ + "img/r-logo-dark.b5e335c8.svg";